import { combineReducers } from 'redux';
import taskReducer from './taskReducer';
import taskActivityReducer from './taskActivityReducer';
import taskActivityReportReducer from './taskActivityReportReducer';
import participantClassReducer from './participantClassReducer';
import participantReducer from './participantReducer';
import departmentReducer from './departmentReducer';
import designationReducer from './designationReducer';
import zoneReducer from './zoneReducer';
import eventReducer from './eventReducer';
import memberReducer from './memberReducer';
import organizationReducer from './organizationReducer';

export default combineReducers({
  tasks: taskReducer,
  taskActivities: taskActivityReducer,
  taskReport: taskActivityReportReducer,
  participantClass: participantClassReducer,
  participant: participantReducer,
  department: departmentReducer,
  designation: designationReducer,
  zone: zoneReducer,
  events: eventReducer,
  member: memberReducer,
  organization: organizationReducer
});
